import { RequestBasePageIds, RequestBaseSet, RequestDeleteIds, ResponseBasePage, ResponseBaseSet } from "src/app/modules/fwcore/models";
import { ModelUpdateAudit } from "src/app/features/prob/models/model-update-audit";


export class RequestModelUpdateAudit extends RequestBasePageIds {

  dealGroupId?: string | null;
  
  dealTypeId?: string | null;

  towerId?: string | null;
}

export class ResponseModelUpdateAudit extends ResponseBasePage<ModelUpdateAudit> {
}

export class RequestModelUpdateAuditSet extends RequestBaseSet<ModelUpdateAudit> {
}

export class ResponseModelUpdateAuditSet extends ResponseBaseSet<ModelUpdateAudit> {
}

export class RequestModelUpdateAuditDelete extends RequestDeleteIds {
}

export class RequestModelUpdateAuditNames {
  dealTypeIds?: string[] | null;
  towerIds?: string[] | null;
}

export class ResponseModelUpdateAuditNames extends ResponseBasePage<string> {
}
